export default __webpack_public_path__ + "static/media/remixicon.d72ac20c.woff";